import PropTypes from 'prop-types';
import './index.scss';

const Checkbox = ({
    value,
    onChange,
    className = '',
    checked = false,
    ...rest
}) => {
    return (
        <input
            type="checkbox"
            value={value}
            onChange={onChange}
            className={`dg-checkbox ${className}`}
            checked={checked}
            {...rest}
        />
    );
};

Checkbox.propTypes = {
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    value: PropTypes.string,
    className: PropTypes.string,
};

export default Checkbox;
